import ErrorPage from "@dashboard/ErrorPage";

export function AccessDeniedPage() {
    return (
        <main className="min-h-fit w-full flex h-full overflow-auto">
            <ErrorPage statusCode="403" />
        </main>
    );
}
